import * as actionTypes from "../constants";
import { updateObject } from "../../utils";

const initialState = {
  tittleNotification: "",
  showNotification: false,
  typeNotification: "",
  contentNotification: "",
};

const setNotification = (state, action) => {
  return updateObject(state, {
    tittleNotification: action.tittle,
    showNotification: action.show,
    typeNotification: action.typeNotification,
    contentNotification: action.content,
  });
};

const notification = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NOTIFICATION:
      return setNotification(state, action);
    default:
      return state;
  }
};

export default notification;
